export const locale = {
  all_providers: 'All Providers',
  soonest_availability: {
    morning: 'Morning Availability',
    afternoon: 'Afternoon Availability',
    evening: 'Evening Availability',
  },
  already_booked_message: 'That appointment time was already booked or not available for booking.',
};
